import { render } from "./AdminSMSAndEmailSetting.vue?vue&type=template&id=194b5edc&scoped=true"
import script from "./AdminSMSAndEmailSetting.vue?vue&type=script&lang=js"
export * from "./AdminSMSAndEmailSetting.vue?vue&type=script&lang=js"

import "./AdminSMSAndEmailSetting.vue?vue&type=style&index=0&id=194b5edc&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194b5edc"]])

export default __exports__